// import React from "react";
// import Footer from "../Header/Footer";
// import HorizontalNav from "../Header/HorizontalNav";
// import { useLocation } from "react-router-dom";

// const Layout = (props) => {
//   const location = useLocation();

//   // Define base routes where Footer should be hidden
//   const noFooterRoutes = ["/add_new_property", "/add_new_project", "/edit_property/", "/Editproject/"];

//   // Check if the current path starts with any route in noFooterRoutes
//   const hideFooter = noFooterRoutes.some(route => location.pathname.startsWith(route));

//   return (
//     <>
//       <HorizontalNav />
//       {props.children}

//       {/* Conditionally render Footer */}
//       {!hideFooter && <Footer />}
//     </>
//   );
// };

// export default Layout;

import React, { useEffect } from "react";
import Footer from "../Header/Footer";
import HorizontalNav from "../Header/HorizontalNav";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

const Layout = (props) => {
  const location = useLocation();

  // Define base routes where Footer should be hidden
  const noFooterRoutes = ["/add_new_property", "/add_new_project", "/edit_property/", "/Editproject/"];

  // Check if the current path starts with any route in noFooterRoutes
  const hideFooter = noFooterRoutes.some((route) => location.pathname.startsWith(route));

  // Initialize Lenis smooth scroll
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
      smoothWheel: true,
      wheelMultiplier: 1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Cleanup on unmount
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <HorizontalNav />
      {props.children}
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;